import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { useCallback } from "react";
import useUserApi from "src/lib/filmwebid/useUserApi";
import { UserApiQueryOptions } from "src/lib/filmwebid/useUserApiQuery";

type UserApiMutationFunctionVariables = {
    params?: any;
    body?: any;
    method?: string;
}

export function useUserApiMutation(path: string, userApiOptions?: UserApiQueryOptions, options?: UseMutationOptions<any, any, any>) {
    const mutationFn = useUserApiMutationFunction(path, userApiOptions);
    return useMutation({
        mutationFn,
        mutationKey: ["userapi", path],
        ...options,
    })
}

function useUserApiMutationFunction(path: string, userApiOptions: UserApiQueryOptions | undefined) {
    const fetcher = useUserApi();
    return useCallback(async (variables: UserApiMutationFunctionVariables) => {
        return fetcher(path, {
            method: userApiOptions?.method ?? "POST",
            allowAnon: userApiOptions?.allowAnon ?? false,
            ...variables,
        });
    }, [fetcher, path, userApiOptions?.allowAnon, userApiOptions?.method]);
}